"use client"

import { useEffect, useState } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter } from "../../lib/tenant"
import "../../styles/TurmaList.css"

export default function TurmaList({ onEdit, keyProp }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [turmas, setTurmas] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTurmas()
  }, [keyProp])

  const fetchTurmas = async () => {
    setLoading(true)
    try {
      let turmasQuery = supabase
        .from("turmas")
        .select(`
          *,
          sala:sala_id(id, nome),
          curso:curso_id(id, nome)
        `)
        .order("nome", { ascending: true })

      turmasQuery = applyInstitutionFilter(turmasQuery, isAdmin, instituicaoId)

      const { data: turmasData, error: turmasError } = await turmasQuery
      if (turmasError) throw turmasError

      const { data: tdData, error: tdError } = await supabase.from("turma_disciplina").select("*")
      if (tdError) throw tdError

      let disciplinasQuery = supabase.from("disciplinas").select("id, nome")
      disciplinasQuery = applyInstitutionFilter(disciplinasQuery, isAdmin, instituicaoId)
      const { data: disciplinasData, error: disciplinasError } = await disciplinasQuery
      if (disciplinasError) throw disciplinasError

      const turmasComDisciplinas = turmasData.map((turma) => {
        const td = tdData.filter((d) => d.turma_id === turma.id)
        const nomesDisciplinas = td
          .map((d) => disciplinasData.find((disc) => disc.id === d.disciplina_id)?.nome)
          .filter(Boolean)
        return { ...turma, disciplinas: nomesDisciplinas }
      })

      setTurmas(turmasComDisciplinas || [])
    } catch (err) {
      console.error("Erro ao buscar turmas:", err.message)
      alert("Erro ao buscar turmas: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (turma) => {
    if (!window.confirm(`Tem certeza que deseja excluir a turma "${turma.nome}"?`)) {
      return
    }

    try {
      // Deletar disciplinas associadas primeiro
      const { error: tdError } = await supabase.from("turma_disciplina").delete().eq("turma_id", turma.id)

      if (tdError) {
        console.error("Erro ao deletar turma_disciplina:", tdError)
      }

      // Deletar horários associados
      const { error: horariosError } = await supabase.from("horarios").delete().eq("turma_id", turma.id)

      if (horariosError) {
        console.error("Erro ao deletar horarios:", horariosError)
      }

      // Deletar turma
      const { error } = await supabase.from("turmas").delete().eq("id", turma.id)

      if (error) throw error

      alert("Turma excluída com sucesso!")
      fetchTurmas()
    } catch (err) {
      console.error("Erro ao excluir turma:", err.message)
      alert("Erro ao excluir turma: " + err.message)
    }
  }

  return (
    <div className="turma-list-container">
      <h3 className="list-title">Turmas Cadastradas</h3>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Carregando turmas...</p>
        </div>
      ) : turmas.length === 0 ? (
        <div className="empty-state">
          <p>Nenhuma turma cadastrada ainda.</p>
        </div>
      ) : (
        <div className="cards-grid">
          {turmas.map((t) => (
            <div key={t.id} className="turma-card">
              <div className="card-header">
                <h3 className="turma-nome">{t.nome}</h3>
                <span className="turma-ano">{t.ano}º Ano</span>
              </div>

              <div className="card-body">
                {t.curso?.nome && (
                  <div className="info-row">
                    <span className="info-label">Curso:</span>
                    <span className="info-value">{t.curso.nome}</span>
                  </div>
                )}
                {t.sala?.nome && (
                  <div className="info-row">
                    <span className="info-label">Sala:</span>
                    <span className="info-value">{t.sala.nome}</span>
                  </div>
                )}
                {t.turno && (
                  <div className="info-row">
                    <span className="info-label">Turno:</span>
                    <span className="info-value">{t.turno}</span>
                  </div>
                )}
                {t.periodo && (
                  <div className="info-row">
                    <span className="info-label">Período:</span>
                    <span className="info-value">{t.periodo}</span>
                  </div>
                )}
                {t.semestre && (
                  <div className="info-row">
                    <span className="info-label">Semestre:</span>
                    <span className="info-value">{t.semestre}</span>
                  </div>
                )}
                {t.trimestre && (
                  <div className="info-row">
                    <span className="info-label">Trimestre:</span>
                    <span className="info-value">{t.trimestre}</span>
                  </div>
                )}

                {t.disciplinas?.length > 0 && (
                  <div className="disciplinas-list">
                    <span className="info-label">Disciplinas:</span>
                    <div className="disciplinas-tags">
                      {t.disciplinas.slice(0, 3).map((disc, idx) => (
                        <span key={idx} className="disc-tag">
                          {disc}
                        </span>
                      ))}
                      {t.disciplinas.length > 3 && <span className="disc-tag more">+{t.disciplinas.length - 3}</span>}
                    </div>
                  </div>
                )}
              </div>

              <div className="card-actions">
                <button className="btn-editar" onClick={() => onEdit && onEdit(t)}>
                  Editar
                </button>
                <button className="btn-excluir" onClick={() => handleDelete(t)}>
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
